import request from '@/utils/request';

//公司
export function getCompany(param) {
  return request('/company/queryList', {
    method: 'GET',
    params: param,
  });
}

//门店
export function getStores(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}

//会员等级
export function getQueryLevels(param) {
  return request('/config/queryLevels', {
    method: 'GET',
    params: param,
  });
}

//分页查询礼品管理列表
export function getGiftQueryPage(values) {
  return request('/gift/queryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}

//表单新增提交
export function postFormData(values) {
  return request('/luckyDraw/add', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//表单更新提交
export function postFormDataUpdate(values) {
  return request('/luckyDraw/update', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//表单详情
export function postFormDetail(values) {
  return request('/queryLuckyDrawDetail', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
